
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SectionTitle } from "@/components/SectionTitle";
import { TestimonialCard } from "@/components/TestimonialCard";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

export const TestimonialsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container-custom">
        <SectionTitle 
          subtitle="Patient Experience" 
          title="What Our Patients Say" 
          description="Hear from our satisfied patients about their experiences at Asrani Dental Clinic and see our comfortable waiting areas designed for your relaxation." 
        />
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-12">
          <div>
            <h3 className="text-2xl font-serif font-medium mb-6 text-dental-text">Patient Testimonials</h3>
            <div className="space-y-6">
              <TestimonialCard 
                name="Rameshwari Sahu" 
                comment="I recently visited Asrani Dental Sadar and was really impressed with their services. I had an OPG scan done, which was quick and painless, and the staff made sure I understood everything. They also handled my child's dental care wonderfully, making it a fun and stress-free experience for them. It's a great place for both adults and kids, with professional and caring staff. Highly recommend!" 
                rating={5} 
                image="/placeholder.svg" 
              />
              
              <TestimonialCard 
                name="Yash Ghoderao" 
                comment="Had a great experience for my braces treatment, just started today. All the process of consultation to OPG and everything was at one place. Looking forward to my new smile in a year." 
                rating={5} 
                image="/placeholder.svg" 
              />
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-serif font-medium mb-6 text-dental-text">Our Welcoming Environment</h3>
            <div className="rounded-xl overflow-hidden shadow-soft">
              <Carousel className="w-full">
                <CarouselContent>
                  <CarouselItem>
                    <div className="relative aspect-[4/3] overflow-hidden rounded-lg">
                      <img 
                        src="/lovable-uploads/29a6ae96-1721-44fd-9f48-207235e5376b.png" 
                        alt="Asrani Dental Clinic Waiting Area" 
                        className="w-full h-full object-cover" 
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                        <p className="text-white font-medium">Comfortable Patient Lounge</p>
                      </div>
                    </div>
                  </CarouselItem>
                  <CarouselItem>
                    <div className="relative aspect-[4/3] overflow-hidden rounded-lg">
                      <img 
                        src="/lovable-uploads/30ec6f89-6b95-44ce-9e61-d19aaeb3698b.png" 
                        alt="Asrani Dental Clinic Reception Area" 
                        className="w-full h-full object-cover" 
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                        <p className="text-white font-medium">Spacious Reception Area</p>
                      </div>
                    </div>
                  </CarouselItem>
                </CarouselContent>
                <CarouselPrevious className="left-2" />
                <CarouselNext className="right-2" />
              </Carousel>
              
              <div className="p-4 bg-white">
                <p className="text-dental-muted">
                  Our clinic features a comfortable, calming waiting area where patients can relax before their appointment, with modern amenities and a soothing atmosphere to help ease any dental anxiety.
                </p>
              </div>
            </div>
            
            <div className="mt-8">
              <Button 
                className="btn-secondary flex items-center text-base group" 
                onClick={() => window.location.href = '/gallery'}
              >
                View More Photos
                <ArrowRight size={18} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
